(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$state', 'Auth', 'Principal', 'ProfileService', 'LoginService'];

    function NavbarController ($state, Auth, Principal, ProfileService, LoginService) {
        var vm = this;

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;
        
        vm.authorityAdmin = "ROLE_CREAZIONE_SP,ROLE_APPROVATORE_SP,ROLE_DASHBOARD_PROVISIONING,ROLE_LOG_ERRORE," +
							"ROLE_CONFIGURAZIONE_PARAM,ROLE_GESTIONE_LISTE_DISTRIBUZIONE,ROLE_GESTIONE_UTENTI" +
							"ROLE_GESTIONE_ESTERNI";

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            //$state.go('home');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }
        
        
    }
})();
